import React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"

export const ThanksPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "THANKS" })

  return (
    <Layout title="THANK YOU" subtitle={t("SUBTITLE")}>
      <Head title="THANK YOU" />
      <Container className="text-center">
        <div className="my-5">
          <h5 className="my-3">{t("1")}</h5>
          <p>{t("2")}</p>
          <p>{t("3")}</p>
        </div>
        <Row className="mt-4 ">
          <Col sm={{ span: 4, offset: 4 }}>
            <a href="/"><Button variant="outline-dark" className="w-100 rounded-0 mb-5">{t("BUTTON_BACK")}</Button></a>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}